// Vendors
import styled from 'styled-components';
// Utilities
import { COBRANDED_LIGHT_REGULAR_STYLES } from '@openbank/ziniaweb-ui-components';

const KycBizumViewStyled = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing_350};

  ${COBRANDED_LIGHT_REGULAR_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    text-align: center;
  }
`;
KycBizumViewStyled.displayName = 'KycBizumViewStyled';

const KycBizumLoaderStyled = styled(KycBizumViewStyled)`
  padding: ${({ theme }) => theme.spacing_350} 0 0;
  gap: ${({ theme }) => theme.spacing_350};
`;
KycBizumLoaderStyled.displayName = 'KycBizumLoaderStyled';

const KycBizumTopLoaderStyled = styled(KycBizumViewStyled)`
  gap: ${({ theme }) => theme.spacing_250};
`;
KycBizumTopLoaderStyled.displayName = 'KycBizumTopLoaderStyled';

export { KycBizumLoaderStyled, KycBizumTopLoaderStyled, KycBizumViewStyled };
